import TYPES from './types';
import { get, put } from 'utils/api';
import { successHandler } from 'common/utils/notifications';
import { updateTableRow, resetTableRowUpdate } from 'store/tables/lists/actions';

export const getWidgetVisibility = params => dispatch => {
  const { id } = params;
  dispatch({ type: TYPES.GET_WIDGET_VISIBILITY.START });

  return get(`/widget-types/${id}/visibility`)
    .then(response => {
      dispatch({ type: TYPES.GET_WIDGET_VISIBILITY.SUCCESS, payload: response.data });
      return response.data;
    })
    .catch(error => dispatch({ type: TYPES.GET_WIDGET_VISIBILITY.ERROR, payload: error }));
};

export const updateWidgetVisibility = params => dispatch => {
  const { id, ...rest } = params;
  dispatch({ type: TYPES.UPDATE_WIDGET_VISIBILITY.START });

  return put(`/widget-types/${id}/visibility`, rest)
    .then(response => {
      dispatch({ type: TYPES.UPDATE_WIDGET_VISIBILITY.SUCCESS, payload: response.data });
      dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));
      return response.data;
    })
    .catch(error => dispatch({ type: TYPES.UPDATE_WIDGET_VISIBILITY.ERROR, payload: error }));
};

export const updateWidgetType = params => dispatch => {
  const { id, table, ...rest } = params;
  dispatch({ type: TYPES.UPDATE_WIDGET_TYPE.START, payload: { params } });
  dispatch(updateTableRow({ data: params, table }));

  return put(`/widget-types/${id}`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.UPDATE_WIDGET_TYPE.SUCCESS, payload: response.data });
      dispatch(updateTableRow({ data: response.data.data, table }));
      dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));

      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.UPDATE_WIDGET_TYPE.ERROR, payload: { response: error, params } });
      dispatch(resetTableRowUpdate({ data: params, table }));
      return error;
    });
};
